module.exports = __webpack_public_path__ + "img/img-3.2557d8ed.png";